import { lazy, Suspense } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { AppShell } from './components/AppShell'
import { BrandGatePage } from './pages/BrandGatePage'
import { useLanguage } from './i18n'

const EvidenceExplorerPage = lazy(() => import('./pages/EvidenceExplorerPage').then((module) => ({ default: module.EvidenceExplorerPage })))
const GoalBuilderPage = lazy(() => import('./pages/GoalBuilderPage').then((module) => ({ default: module.GoalBuilderPage })))
const InteractionExplorerPage = lazy(() => import('./pages/InteractionExplorerPage').then((module) => ({ default: module.InteractionExplorerPage })))
const RunResultsPage = lazy(() => import('./pages/RunResultsPage').then((module) => ({ default: module.RunResultsPage })))
const StackAuditPage = lazy(() => import('./pages/StackAuditPage').then((module) => ({ default: module.StackAuditPage })))
const StackBuilderPage = lazy(() => import('./pages/StackBuilderPage').then((module) => ({ default: module.StackBuilderPage })))
const StackLibraryPage = lazy(() => import('./pages/StackLibraryPage').then((module) => ({ default: module.StackLibraryPage })))
const SubstanceLibraryPage = lazy(() => import('./pages/SubstanceLibraryPage').then((module) => ({ default: module.SubstanceLibraryPage })))
const SubstanceProfilePage = lazy(() => import('./pages/SubstanceProfilePage').then((module) => ({ default: module.SubstanceProfilePage })))

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<RouteLoading />}>
        <Routes>
          <Route path="/" element={<BrandGatePage />} />
          <Route element={<AppShell />}>
            <Route path="/app" element={<GoalBuilderPage />} />
            <Route path="/runs/:runId" element={<RunResultsPage />} />
            <Route path="/runs/:runId/stacks/:stackId" element={<StackAuditPage />} />
            <Route path="/stacks" element={<StackLibraryPage />} />
            <Route path="/stacks/:stackId" element={<StackAuditPage />} />
            <Route path="/substances" element={<SubstanceLibraryPage />} />
            <Route path="/substances/:substanceId" element={<SubstanceProfilePage />} />
            <Route path="/interactions" element={<InteractionExplorerPage />} />
            <Route path="/evidence" element={<EvidenceExplorerPage />} />
            <Route path="/builder" element={<StackBuilderPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

function RouteLoading() {
  const { tr } = useLanguage()
  return <div className="page-wrap"><div className="state-panel"><span className="button-spinner" /><h2>{tr('loading')}</h2></div></div>
}

function NotFound() {
  const { tr } = useLanguage()
  return <div className="page-wrap"><div className="state-panel is-empty"><span>404</span><h2>{tr('notFoundTitle')}</h2><p>{tr('notFoundBody')}</p><a className="primary-button" href="/app">{tr('newResearch')}</a></div></div>
}
